import { render } from "./RestaurantStatusPopup.vue?vue&type=template&id=7de98158&scoped=true"
import script from "./RestaurantStatusPopup.vue?vue&type=script&lang=js"
export * from "./RestaurantStatusPopup.vue?vue&type=script&lang=js"

import "./RestaurantStatusPopup.vue?vue&type=style&index=0&id=7de98158&scoped=true&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7de98158"]])

export default __exports__